// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ConferenceInfo_wrapper__yEO0p","bigWrapper":"ConferenceInfo_bigWrapper__miNul","box":"ConferenceInfo_box__qpJIK"};